import api from "@/lib/api";

const SID_KEY = "gcw_home_sid";
const VAR_KEY = "gcw_home_variant";
const LOC_KEY = "gcw_req_loc";

export const sessionId = () => {
  let s = window.sessionStorage.getItem(SID_KEY);
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); window.sessionStorage.setItem(SID_KEY, s); }
  return s;
};
export const homeVariant = () => window.sessionStorage.getItem(VAR_KEY);
export const setHomeVariant = (v) => window.sessionStorage.setItem(VAR_KEY, v);

export function trackHome(event, meta = {}) {
  const variant = homeVariant();
  if (!variant) return;
  api.post("/analytics/homepage-event", { variant, event, session_id: sessionId(), meta }).catch(() => {});
}

export const getSavedLocation = () => { try { return JSON.parse(window.sessionStorage.getItem(LOC_KEY) || "{}"); } catch (_) { return {}; } };
export const setSavedLocation = (loc) => window.sessionStorage.setItem(LOC_KEY, JSON.stringify(loc || {}));

let catPromise = null;
export const getCategories = () => {
  if (!catPromise) catPromise = api.get("/categories").then(({ data }) => (Array.isArray(data) ? data : data?.items || [])).catch(() => { catPromise = null; return []; });
  return catPromise;
};

const PARAM = { category_id: "cat", subcategory_id: "sub", search_text: "q", request_source: "src", zip: "zip", city: "city", urgency: "urgency",
  deal_id: "deal", provider_id: "provider", service_id: "svc", campaign: "campaign", homepage_component: "component" };

// Builds the Request-a-Service URL for a request context (see CONTEXT_KEYS on the backend).
export function buildRequestUrl(ctx = {}) {
  const loc = getSavedLocation();
  const full = { zip: loc.zip, city: loc.city, homepage_variant: homeVariant(), ...ctx };
  const sp = new URLSearchParams();
  Object.entries(PARAM).forEach(([k, p]) => { if (full[k]) sp.set(p, full[k]); });
  if (full.homepage_variant) sp.set("hv", full.homepage_variant);
  return `/request-a-service?${sp.toString()}`;
}

export function readRequestContext(sp) {
  const ctx = {};
  Object.entries(PARAM).forEach(([k, p]) => { if (sp.get(p)) ctx[k] = sp.get(p); });
  if (sp.get("hv")) ctx.homepage_variant = sp.get("hv");
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => { if (sp.get(k)) ctx[k] = sp.get(k); });
  if (!ctx.request_source && (sp.get("source") || sp.get("utm_source"))) ctx.request_source = sp.get("source") || sp.get("utm_source");
  if (!ctx.campaign && sp.get("utm_campaign")) ctx.campaign = sp.get("utm_campaign");
  if (document.referrer && !document.referrer.startsWith(window.location.origin)) ctx.referrer = document.referrer.slice(0, 200);
  return ctx;
}

// Resolve a category slug into {category_id, subcategory_id} using the cached category list.
export async function contextForSlug(slug) {
  const cats = await getCategories();
  const c = cats.find((x) => x.slug === slug);
  if (!c) return {};
  return c.parent_id ? { category_id: c.parent_id, subcategory_id: c.id } : { category_id: c.id };
}
